import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const routes: RouteRecordRaw[] = [
  { path: '/', name: 'home', component: () => import('@/pages/HomePage.vue'), meta: { requiresAuth: true } },
  { path: '/login', name: 'login', component: () => import('@/pages/LoginPage.vue') },
  { path: '/liff/entry', name: 'liff-entry', component: () => import('@/pages/LiffEntryPage.vue') },
  {
    path: '/ledgers/:id',
    name: 'ledger',
    component: () => import('@/pages/LedgerDetailPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/ledgers/:id/expenses/new',
    name: 'expense-new',
    component: () => import('@/pages/ExpenseNewPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/ledgers/:id/expenses/:eid/edit',
    name: 'expense-edit',
    component: () => import('@/pages/ExpenseEditPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/ledgers/:id/repayment',
    name: 'ledger-repayment',
    component: () => import('@/pages/RepaymentPage.vue'),
    meta: { requiresAuth: true },
  },
  // Old aliases — kept so chat-history deep links keep working.
  { path: '/ledgers/:id/graph', redirect: (to) => ({ name: 'ledger-repayment', params: to.params }) },
  { path: '/ledgers/:id/settlements', redirect: (to) => ({ name: 'ledger-repayment', params: to.params }) },
  { path: '/ledgers/:id/groups', redirect: (to) => ({ name: 'ledger-members', params: to.params }) },
  {
    path: '/ledgers/:id/rates',
    name: 'ledger-rates',
    component: () => import('@/pages/RatesPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/ledgers/:id/history',
    name: 'ledger-history',
    component: () => import('@/pages/HistoryPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/ledgers/:id/members',
    name: 'ledger-members',
    component: () => import('@/pages/MembersPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/groups/:lineGroupId',
    name: 'group-ledgers',
    component: () => import('@/pages/GroupLedgersPage.vue'),
    meta: { requiresAuth: true },
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  if (!to.meta.requiresAuth) return true;
  const auth = useAuthStore();
  if (auth.user) {
    auth.revalidate();
    return true;
  }
  const ok = await auth.fetchMe();
  if (!ok) return { name: 'login', query: { next: to.fullPath } };
  return true;
});
